import {GET_BETS as SOCKET_GET_BETS} from '../../events/DashboardToServer'
import { ANSWER_PROCESSED } from '../userAnswer/actions';

const GET_BETS = 'GET_BETS'
const RECEIVE_BETS = 'RECEIVE_BETS'

export const bets = (state = {}, action) => {
    switch (action.type) {
        case RECEIVE_BETS:
            var ss = {
                ...state,
            }
            ss[action.user_id] = action.bets
            return ss  
        
        case ANSWER_PROCESSED:
            var s = {
                ...state,
            }
            if (!s[action.user_id]) s[action.user_id] = [];
            var find = false; 
            for (var i = 0; i < s[action.user_id].length; i++){
                if  (s[action.user_id][i].question_id === action.user_answer.question_id && 
                        s[action.user_id][i].game_id === action.user_answer.game_id){
                            s[action.user_id][i] = action.user_answer;
                            find = true;
                            break;
                        }
            }
            if (!find) s[action.user_id].push({...action.user_answer});
            return s  

        default:
            return state
    }
}

export const getBets = (socket, user_id, game_id) => {
    socket.emit(SOCKET_GET_BETS, user_id, game_id)
    return { type: GET_BETS, user_id, game_id }
}

export const receiveBets = (bets, user_id) => {
    return { type: RECEIVE_BETS, bets, user_id }
}


// WEBPACK FOOTER //
// ./src/reducers/bets/index.js